var _path, _path2, _circle, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMinorAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M19.7 33.7l5.6 2.6 14.5-6.5V12.5M39.8 12.5L25.1 7l-14.9 6.1v3.7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M10.2 13.1l15.1 5.5 14.5-6.1M25.3 19.1v15.5M30 22.2l5.2-2.2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 30,
    cy: 27.2,
    r: 1.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M19.7 26.8H8.5M14.1 21.2v11.2M19.7 26.8H8.5M14.1 21.2v11.2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMinorAsset);
export default __webpack_public_path__ + "static/media/addMinorAsset.6bccf0e6a2d8b901ebc176073af8d414.svg";
export { ForwardRef as ReactComponent };